import { useRouter } from "next/navigation";
import { useCallback } from "react";
import { useTranslation } from "@/i18n/client";
import { buildLocalizedPath, isAbsoluteHttpUrl } from "@/utils/language";

export function useLocalizedRouter() {
  const router = useRouter();
  const { i18n } = useTranslation("global");

  const getLocalizedPath = useCallback(
    (path: string) => {
      const currentLang = i18n.language;
      const localizedPath = buildLocalizedPath(path, currentLang);
      return localizedPath;
    },
    [i18n.language]
  );

  const navigateTo = useCallback(
    (path: string, withoutCache = false) => {
      if (isAbsoluteHttpUrl(path)) {
        window.location.assign(path);
        return;
      }

      const localizedPath = getLocalizedPath(path);

      if (withoutCache) {
        window.location.assign(localizedPath);
      } else {
        router.push(localizedPath);
      }
    },
    [getLocalizedPath, router]
  );

  const navigateToNewTab = useCallback(
    (path: string) => {
      if (isAbsoluteHttpUrl(path)) {
        window.open(path, "_blank");
        return;
      }

      const localizedPath = getLocalizedPath(path);

      window.open(localizedPath, "_blank");
    },
    [getLocalizedPath]
  );

  return { navigateTo, navigateToNewTab };
}
